import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  inactive?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    size: { default: 'md' },
    color: { default: '#5a5a5a' },
    inactive: { type: Boolean }
  },
  setup(__props: any) {



const sizes = {
  sm: 'base-spin--sm',
  md: 'base-spin--md',
  lg: 'base-spin--lg',
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-spin", [sizes[__props.size], { 'base-spin--inactive': __props.inactive }]]),
    style: _normalizeStyle({ 'border-right-color': __props.inactive ? undefined : __props.color })
  }, null, 6))
}
}

})